import { ExpandableCard } from "@components/ExpandableCard";
import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall, Caption, Title3 } from "@components/Typography";
import { Translations, i18n } from "@i18n";
import { Shield } from "./Shield";
import { useStyles } from "./styles";
import { SsnDisclaimerProps } from "./types";

const BulletItem = ({ text }: { text: string }) => {
  const styles = useStyles();

  return (
    <div style={styles.bulletItem}>
      <Caption style={{ ...styles.legalText, ...styles.bullet }}>{"•"}</Caption>
      <Caption style={styles.legalText}>{text}</Caption>
    </div>
  );
};

export const SsnDisclaimer = ({ subtitle, style }: SsnDisclaimerProps) => {
  const styles = useStyles();

  return (
    <>
      <div style={{ ...styles.card, ...style }}>
        <Row style={styles.header}>
          <Shield />
          <Title3 style={styles.title}>{i18n.t(Translations.SsnRouteDisclaimerTitle)}</Title3>
        </Row>
        <Spacing size={SpacingSizes.S} />
        <BodySmall style={styles.subtitle}>{subtitle}</BodySmall>
        <Spacing size={SpacingSizes.M} />
        <div style={styles.badges}>
          <div style={styles.badge}>
            <BodySmall>🔒</BodySmall>
            <Spacing size={SpacingSizes.XS} />
            <Caption style={styles.badgeLabel}>
              {i18n.t(Translations.SsnRouteDisclaimerBadge1)}
            </Caption>
          </div>
          <div style={styles.badge}>
            <BodySmall>🏛</BodySmall>
            <Spacing size={SpacingSizes.XS} />
            <Caption style={styles.badgeLabel}>
              {i18n.t(Translations.SsnRouteDisclaimerBadge2)}
            </Caption>
          </div>
          <div style={styles.badge}>
            <BodySmall>📋</BodySmall>
            <Spacing size={SpacingSizes.XS} />
            <Caption style={styles.badgeLabel}>
              {i18n.t(Translations.SsnRouteDisclaimerBadge3)}
            </Caption>
          </div>
        </div>
      </div>
      <Spacing size={SpacingSizes.M} />
      <ExpandableCard title={i18n.t(Translations.SsnRouteLegalTitle)}>
        <Caption style={styles.legalText}>{i18n.t(Translations.SsnRouteLegalInfo1)}</Caption>
        <Spacing size={SpacingSizes.S} />
        <BulletItem text={i18n.t(Translations.SsnRouteLegalInfo2)} />
        <Spacing size={SpacingSizes.XS} />
        <BulletItem text={i18n.t(Translations.SsnRouteLegalInfo3)} />
        <Spacing size={SpacingSizes.XS} />
        <BulletItem text={i18n.t(Translations.SsnRouteLegalInfo4)} />
        <Spacing size={SpacingSizes.S} />
        <Caption style={styles.legalText}>{i18n.t(Translations.SsnRouteLegalInfo5)}</Caption>
      </ExpandableCard>
    </>
  );
};
